// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3Kd9Z","content":"GlobalSearch_content__3QaEL"};